import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import ResultContainer from "../components/Results/ResultContainer";

const names = require("@rstacruz/startup-name-generator");

export default function Results() {

    const [keywords, setKeywords] = useState([])
    const location = useLocation();

    useEffect(() => {
        var entryData;
        if(!location.state){
            entryData = location.pathname.slice(18).replace("+"," ");
            setKeywords(names(entryData))
        } else {
            entryData = location.state.data;
            setKeywords(names(entryData));
        }
    }, [])

    return(
        <>
            <Navbar fixed />
            <main>
                <div className="relative pt-12 pb-32 flex content-center items-center justify-center min-h-screen-75">
                    <div className="absolute top-0 w-full h-full bg-center bg-blueGray-200">
                        <ResultContainer nameGenerated={keywords} />
                    </div>
                </div>
            </main>
        </>
    )
}